import React from 'react';

export default function ExportButton({ orders }) {
  const handleExport = () => {
    if (orders.length === 0) {
      alert('No data to export.');
      return;
    }

    const headers = ['Order ID', 'Kiosk', 'Beverage', 'Amount (₹)', 'Status', 'Timestamp'];
    const rows = orders.map((o) => [
      o.id,
      o.kiosk_id || '',
      o.item_id ? o.item_id.replace('juice_', '').replace(/_/g, ' ').toUpperCase() : '',
      o.amount || 19,
      o.status || '',
      o.timestamp ? new Date(o.timestamp).toISOString() : '',
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `chillras_orders_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <button id="export-csv-button" className="export-btn" onClick={handleExport}>
      <span>📥</span> Export CSV
    </button>
  );
}
